import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const workbookAccelerationSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'hits': SortOptions.hits,
  'sheet': SortOptions.sheetIndex,
};